<template>
    <div class="header-container">
        <van-icon class="header-bar-btn" name="bars" @click="handleClick" />
        <div class="title">{{title}}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    methods: {
        handleClick() {
            let _self = this;
            _self.$emit("showLeftMenuClick");

        }
    }
}
</script>

<style scoped>
.header-container {
    height: 6vh;
    padding-left: 6px;
    padding-top: 4px;
}

.header-container .header-bar-btn {
    position: absolute;
    font-size: 4vh;
}

.header-container .title {
    text-align: center;
    line-height: 4vh;
    font-size: 22px;
}
</style>